import React from 'react';
import { useTranslation } from 'react-i18next';

const KINDS = ['individual', 'company'];

/**
 * « Particulier » or « Entreprise » for a billing client: two large radio
 * cards (easy to hit on a tablet), each saying what it changes.
 */
export default function PartyKindToggle({ value, onChange, name = 'party-kind' }) {
  const { t } = useTranslation();
  const current = value === 'individual' ? 'individual' : 'company';
  return (
    <fieldset className="party-kind">
      <legend className="party-kind-legend">{t('clients.kindLegend')}</legend>
      <div className="party-kind-options">
        {KINDS.map((kind) => (
          <label key={kind} className={`party-kind-option${current === kind ? ' is-selected' : ''}`}>
            <input
              type="radio"
              name={name}
              value={kind}
              checked={current === kind}
              onChange={() => onChange(kind)}
            />
            <span className="party-kind-title">{t(`clients.kind_${kind}`)}</span>
            <span className="party-kind-hint">{t(`clients.kindHint_${kind}`)}</span>
          </label>
        ))}
      </div>
    </fieldset>
  );
}
